import { render, staticRenderFns } from "./BirthdayList.vue?vue&type=template&id=7fc92082"
import script from "./BirthdayList.ts?vue&type=script&lang=ts&external"
export * from "./BirthdayList.ts?vue&type=script&lang=ts&external"
import style0 from "./BirthdayList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports